<template>
  <button
    :aria-label="title"
    :title="title"
    class="i-button btn"
    :class="[`i-${variant}-btn`, { active, compact }]"
    type="button"
    :disabled="disabled"
    :tabindex="disabled ? -1 : 0"
    ref="button"
    @focus="active = true"
    @blur="active = false"
  >
    <span class="sr-only">{{ title }}</span>
    <!-- @slot Use this slot to place the button content -->
    <slot></slot>
  </button>
</template>

<script>
import Icon from '../icon/Icon.vue'

export default {
  name: 'i-button',
  components: {
    [Icon.name]: Icon
  },
  props: {
    /**
     * Sets the `aria-label` and the `title` attributes of the button
     */
    title: {
      type: String
    },
    variant: {
      type: String,
      default: 'simple',
      validator(value) {
        return ['primary', 'secondary', 'simple'].includes(value)
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false
    }
  },
  methods: {
    focus() {
      const { button } = this.$refs
      if (button) button.focus()
    }
  }
}
</script>

<style scoped lang="scss">
.i-button:focus {
  outline: 0;
}
.i-button.i-simple-btn.active {
  color: $blue;
  background: $ibutton-bg-hover-color-light;
}
.i-button.compact {
  padding: 5px 10px;
  text-transform: none;
}
</style>
